import { createSelector } from '@reduxjs/toolkit';
import adapter from './adapter';

const getLoadingState = createSelector(
  (state) => state?.invoice,
  (invoice) => invoice.loading,
);

const getMetaData = createSelector(
  (state) => state?.invoice,
  (invoice) => invoice.meta,
);

const getPendingSummary = createSelector(
  (state) => state?.invoice,
  // Guarded through: the cart reads this to decide whether to ask for a
  // delivery date, so an absent slice has to yield nothing, not throw.
  (invoice) => invoice?.pendingSummary,
);

const selectors = {
  getLoadingState,
  getMetaData,
  getPendingSummary,
  ...adapter.getSelectors((state) => state.invoice),
};

export default selectors;
